import qs from 'qs';

import { AGENT_DEFINITIONS_PAGE_SIZE } from 'src/components/pipelines/constants';
import envBaseUrl from 'src/components/pipelines/utils/env-base-url';
import {
  capturePipelinesExceptionWithTags,
  createErrorMessage,
} from 'src/components/pipelines/utils/sentry';
import {
  publishTrackEvent,
  type TrackEvent,
} from 'src/utils/analytics/publish';
import { authRequest, jsonHeaders } from 'src/utils/fetch';

export const getAgentDefinitionsUrl = (
  repositoryFullSlug: string,
  ref: string,
  queryParams: any = {}
): string => {
  const allQueryParams = {
    page: 1,
    pagelen: AGENT_DEFINITIONS_PAGE_SIZE,
    revision: ref,
    ...queryParams,
  };
  return `${envBaseUrl(
    '/!api/internal'
  )}/repositories/${repositoryFullSlug}/agents/definitions?${qs.stringify(
    allQueryParams
  )}`;
};

export const getAgentSessionsUrl = (repositoryFullSlug: string): string => {
  return `${envBaseUrl(
    '/!api/internal'
  )}/repositories/${repositoryFullSlug}/agents/sessions/`;
};

export const getAiUrl = (repositoryFullSlug: string): string =>
  `${envBaseUrl('/!api/internal')}/repositories/${repositoryFullSlug}/ai`;

export const getCheckForPipelineConfigurationUrl = (
  repositoryFullSlug: string
): string =>
  `${envBaseUrl(
    '/!api/internal'
  )}/repositories/${repositoryFullSlug}/check-for-pipeline`;

export const getPostRequestHeaders = (data: object): RequestInit => ({
  method: 'POST',
  headers: jsonHeaders,
  body: JSON.stringify(data),
});

export async function fetchData(
  url: string,
  options: RequestInit = {},
  sentryErrorSegment: string,
  responseType: 'json' | 'text' = 'json'
): Promise<any> {
  try {
    const req = authRequest(url, options);
    const resp = await fetch(req);

    if (!resp.ok) {
      throw new Error(await createErrorMessage(resp));
    }

    const data =
      responseType === 'json' ? await resp.json() : await resp.text();
    return data;
  } catch (e) {
    capturePipelinesExceptionWithTags(e, {
      segment: sentryErrorSegment,
    });
    throw e;
  }
}

const stripUuidBraces = (uuid?: string) => uuid?.replace(/{|}/g, '');

export const customAnalyticsFire = (
  aiEvent: any,
  repositoryUuid: string,
  pipelineUuid?: string,
  buildNumber?: number,
  commitHash?: string,
  pullrequestId?: string,
  stepUuid?: string,
  accountId?: string
) => {
  const event = {
    ...aiEvent,
    attributes: {
      ...aiEvent.attributes,
      repositoryId: stripUuidBraces(repositoryUuid),
      ...(pipelineUuid ? { pipelineId: stripUuidBraces(pipelineUuid) } : {}),
      ...(buildNumber ? { buildNumber } : {}),
      ...(commitHash ? { commitHash } : {}),
      ...(pullrequestId ? { pullrequestId } : {}),
      ...(stepUuid ? { stepId: stripUuidBraces(stepUuid) } : {}),
      ...(accountId ? { accountId } : {}),
    },
  };
  publishTrackEvent(event as TrackEvent);
};
